export default __webpack_public_path__ + "static/media/DSC_0563.9ba00ac2.jpg";